import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import useInvalidateFetchAllProperties from 'components/domain/property/useInvalidateFetchAllProperties';
import useAppMutation from 'hooks/useAppMutation';
import useNotify from 'hooks/useNotify';
import API from 'services/API';
import { PROPERTIES_FOR_PROPERTIES_BODY_BASE_QUERY_KEY } from 'pages/agencyProperties/body/useFetchPropertiesForPropertiesBody';

interface LinkSubUnitsArgs {
  propertyUid: string;
  propertyUidsToLink: string[];
}

const linkSubUnits = async ({
  propertyUid,
  propertyUidsToLink,
}: LinkSubUnitsArgs) => {
  return API.post(`/api/internal/properties/${propertyUid}/link-sub-units`, {
    propertyUidsToLink,
  });
};

const useLinkSubUnitsMutation = ({
  onSuccess,
}: {
  onSuccess: (data: unknown, variables: LinkSubUnitsArgs) => void;
}) => {
  const { notifyError, notifySuccess } = useNotify();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { invalidateFetchAllProperties } = useInvalidateFetchAllProperties();

  return useAppMutation({
    mutationFn: linkSubUnits,
    onSuccess: (data, variables) => {
      onSuccess(data, variables);
      notifySuccess(
        t('pageProperties.actions.linkSubUnitsModal.onSubmitSuccess'),
      );
      invalidateFetchAllProperties();
    },
    onSettled: () => {
      queryClient.invalidateQueries([
        PROPERTIES_FOR_PROPERTIES_BODY_BASE_QUERY_KEY,
      ]);
    },
    onError: () => {
      notifyError(t('pageProperties.actions.linkSubUnitsModal.onSubmitError'));
    },
  });
};

export default useLinkSubUnitsMutation;
